module.exports = __webpack_public_path__ + "img/mercantile-large.c8d3f867.png";